<template>
  <a-layout>
    <receipt-order ref="receiptOrder" :order-status-data="orderStatusData" :refundable="refundable" :storer-data="storerData" @rowClick="rowClick" />
    <receipt-detail ref="receiptDetail" :refundable="refundable" style="margin-top: 2px" @rowDblClick="rowDblClick" />
  </a-layout>
</template>

<script>
  import ReceiptOrder from '@/views/inbound/receipt/ReceiptOrder.vue'
  import ReceiptDetail from '@/views/inbound/receipt/ReceiptDetail.vue'

  export default {
    name: 'ReceiptQuery',
    components: { ReceiptDetail, ReceiptOrder },
    props: {
      refundable: {
        type: Boolean,
        default: false
      },
      orderStatusData: {
        type: Array,
        default: []
      },
      storerData: {
        type: Array,
        default: []
      }
    },
    methods: {
      rowClick(orderId) {
        this.$refs.receiptDetail.getData(orderId)
      },
      rowDblClick(detail) {
        this.$emit('rowDblClick', detail)
      },
      reset() {
        this.$refs.receiptDetail.reset()
        this.$refs.receiptOrder.reset()
      },
      supervise() {

      },
      baseDataEdit() {

      },
      save() {

      },
      pickUp() {

      },
      rejectPrint() {

      }
    }
  }
</script>